var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#818181",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#818181",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.955 2.05c4.365 0 7.904 3.539 7.904 7.905 0 2.547-1.3 5.13-3.738 7.704-.61.644-1.269 1.262-1.962 1.845l-.527.431-.222.175-.41.311-.195.143-.323.226c-.284.19-.644.21-.946.063l-.11-.063-.523-.374-.41-.311-.217-.17c-.887-.707-1.726-1.471-2.488-2.276C5.35 15.086 4.05 12.502 4.05 9.955c0-4.366 3.539-7.905 7.905-7.905zm0 1.9c-3.317 0-6.005 2.688-6.005 6.005 0 2 1.108 4.17 3.217 6.397.56.591 1.167 1.16 1.807 1.698l.485.397.198.156.297.226.292-.221.203-.16c.819-.652 1.594-1.357 2.293-2.096 2.11-2.226 3.217-4.398 3.217-6.397 0-3.317-2.688-6.005-6.004-6.005zm0 2.736c1.805 0 3.268 1.464 3.268 3.269 0 1.805-1.463 3.268-3.268 3.268-1.805 0-3.269-1.463-3.269-3.268 0-1.805 1.464-3.269 3.269-3.269zm0 1.9c-.756 0-1.369.613-1.369 1.369 0 .755.613 1.368 1.369 1.368.755 0 1.368-.613 1.368-1.368 0-.756-.613-1.369-1.368-1.369z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.ce2917325ba1e1f0eda43dfe630b8223.svg";
export { ForwardRef as ReactComponent };